import axios from 'axios'

/**
 * El histórico interno de trazabilidad es de control interno: solo lo consultan
 * los perfiles responsables autorizados en el backend.
 */
export const canAccessRequestHistory = async () => {
  const token = localStorage.getItem('token')
  if (!token) return false

  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}/request/history/access`,
      {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    )

    return response.data?.value?.allowed === true
  } catch {
    return false
  }
}

export const fetchRequestHistory = async (requestId, { page = 1, perPage = 25 } = {}) => {
  const token = localStorage.getItem('token')

  const response = await axios.get(
    `${import.meta.env.VITE_API_URL}/request/${requestId}/history`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
      params: { page, per_page: perPage },
    },
  )

  return response.data?.value
}
